import { Target, Sprout, Shield } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'
import { sectionImages } from '../data/imageBank'

export default function Orchards() {
  const { t } = useLanguage()

  const stats = [
    { value: '40 hectares', label: t('orchards.stat1Label'), color: 'text-ng-mid' },
    { value: '650 tonnes', label: t('orchards.stat2Label'), color: 'text-ng-gold' },
    { value: '37 emplois', label: t('orchards.stat3Label'), color: 'text-ng-brown' },
  ]

  const cards = [
    {
      icon: <Target className="w-7 h-7 text-ng-mid" />,
      title: t('orchards.card1Title'),
      text: t('orchards.card1Text'),
    },
    {
      icon: <Sprout className="w-7 h-7 text-ng-mid" />,
      title: t('orchards.card2Title'),
      text: t('orchards.card2Text'),
    },
    {
      icon: <Shield className="w-7 h-7 text-ng-mid" />,
      title: t('orchards.card3Title'),
      text: t('orchards.card3Text'),
    },
  ]

  return (
    <section id="orchards" className="py-20 lg:py-32 bg-ng-beige">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-medium text-ng-brown uppercase tracking-wider">{t('orchards.kicker')}</span>
          <h2 className="font-display text-4xl lg:text-5xl text-ng-dark mt-3 mb-6 font-bold">
            {t('orchards.title')}
          </h2>
          <p className="text-lg text-ng-dark/70 leading-relaxed">
            {t('orchards.intro')}
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 lg:gap-12 mb-16">
          {stats.map(({ value, label, color }) => (
            <div key={label} className="text-center">
              <div className={`font-display text-4xl lg:text-5xl font-bold ${color} mb-2`}>{value}</div>
              <div className="text-sm text-ng-dark/60">{label}</div>
            </div>
          ))}
        </div>

        {/* Image with overlay */}
        <div className="relative mb-16 rounded-2xl overflow-hidden shadow-xl">
          <img
            src={sectionImages.orchards}
            alt="Vergers circulaires"
            className="w-full h-[400px] lg:h-[500px] object-cover"
            loading="lazy"
            decoding="async"
            onError={(e) => {
              e.target.style.display = 'none'
              e.target.parentElement.querySelector('.img-fallback').style.display = 'flex'
            }}
          />
          <div
            className="img-fallback w-full h-[400px] lg:h-[500px] hidden items-center justify-center"
            style={{ background: 'linear-gradient(135deg,#2d6640 0%,#4a7c2a 60%,#5a9a3c 100%)' }}
          >
            <span className="text-white/30 text-sm">orchard.jpg</span>
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-ng-dark/60 to-transparent" />
          <div className="absolute bottom-8 left-8 right-8">
            <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 max-w-md">
              <div className="text-sm font-medium text-ng-brown mb-2">{t('orchards.overlayTitle')}</div>
              <div className="text-ng-dark">{t('orchards.overlayText')}</div>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {cards.map(({ icon, title, text }) => (
            <div key={title} className="card-hover bg-white rounded-2xl p-8 shadow-sm border border-ng-dark/5">
              <div className="w-14 h-14 rounded-xl bg-ng-mid/10 flex items-center justify-center mb-6">
                {icon}
              </div>
              <h3 className="font-display text-xl text-ng-dark mb-4 font-semibold">{title}</h3>
              <p className="text-ng-dark/60 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
